<!-- 
########################################### 
 script setup                                       
###########################################
-->
<script setup lang="ts">
import { ref, watch} from "vue"

export interface Props {
  message: string
  show: boolean
  type: string
  cancel: boolean
}

const localShow = ref(false)

let timeId:number

const props = withDefaults(defineProps<Props>(),{
  message: '',
  show: false,
  type: 'info',
  cancel: false
})
const emit = defineEmits<{
  (e: 'setShow', show: boolean): void
}>()

const closeFlashMessage = () => {
  timeId = setTimeout(() => {
    localShow.value = false
    emit('setShow', false)
  }, 10000);
}
const cancelSetTimeOut = () => {
  clearTimeout(timeId);
}

watch(() => props.show, () => {
  localShow.value = props.show
  if (localShow.value) {
    closeFlashMessage()
  }
});
watch(() => props.cancel, () => {
  if (props.cancel) {
    cancelSetTimeOut()
  }
});

</script>

<!-- 
########################################### 
 template                                       
###########################################
-->
<template>
  <div
    id="modal-flash-message"
    v-if="localShow"
    class="modal-flash-message"
  >
    <div
      class="pt-2 pb-2 pl-6"
      :class="type"
    >
      {{ message }}
    </div>
  </div>

</template>

<!-- 
########################################### 
 style                                       
###########################################
-->
<style>
div.modal-flash-message{
  width: 100%;
}
div.modal-flash-message div.info{
  color: rgb(var(--v-theme-on-success));
  background-color: rgb(var(--v-theme-success));
}
div.modal-flash-message div.error{
  color: rgb(var(--v-theme-on-error))!important;
  background-color: rgb(var(--v-theme-error))!important;
}
</style>


